module.exports = __webpack_public_path__ + "static/img/frame 2.ec6415b5.png";